import { render } from "./ApplicationsPage.vue?vue&type=template&id=593c1e3b&ts=true"
import script from "./ApplicationsPage.vue?vue&type=script&lang=ts"
export * from "./ApplicationsPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__